import { render, staticRenderFns } from "./FavoriteMessageItem.vue?vue&type=template&id=2fa7835b&scoped=true"
import script from "./FavoriteMessageItem.vue?vue&type=script&lang=js"
export * from "./FavoriteMessageItem.vue?vue&type=script&lang=js"
import style0 from "./FavoriteMessageItem.vue?vue&type=style&index=0&id=2fa7835b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/lyb/工作/个人/leo——im/新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa7835b",
  null
  
)

export default component.exports